import apiService from '../index';

class LeaguesManager {
  constructor() {
    this.apiService = apiService;
  }

  async fetchLeagues() {
    try {
      console.log('Fetching leagues data using LeaguesManager...');
      
      // Используем метод get, который уже проверяет кэш и делает запрос к API только если нужно
      const response = await this.apiService.getLeagues();
      console.log('Leagues API response:', response);
      
      if (response.status === 'error') {
        console.error('Error fetching leagues:', response.message);
        return response;
      }
      
      return {
        status: 'success',
        data: response.data,
        endpoint: 'leagues',
        fromCache: response.fromCache
      };
    } catch (error) {
      console.error('Error in LeaguesManager:', error);
      return {
        status: 'error',
        message: error.message,
        endpoint: 'leagues'
      };
    }
  }
}

export default new LeaguesManager(); 